
const S380 = {
  header: {
    category: "Fogászati Kezelőegység",
    model: "S380",
    tagline: "A fogászati ​​technológia csúcsa.",
  },

  hero: {
    image: "/uploads/S380.png",
    buttonText: "Digitális bemutatóterem",
    title: "Számos opcionális funkcióval és funkcióval rendelkező kezelőegység",
    description:
      "Az S380TRC az exkluzív ergonómiát a legújabb generációs technológiával ötvözi, így páratlan felhasználói élményt nyújt az orvosok és a betegek számára.",
    showroom: "https://www.vitshowroom.it/interactive/sternweber/index.php?IDmodello=1800&param=sala1,-138.78,-19.20,57.07,4,ENG"  
  },

  description: {
    title: "Korszerű rendszer",
    columns: [
      [
        "TOP modell forgószékkel",
        "A szék lábtartójának összecsukási lehetősége is van.",
        "The chair moves on a spittoon block",
      ],
      [
        "A betegszék 90°-ban elforgatható",
        "Kivételes ergonómiai kényelem mind a páciens, mind a fogászati ​​csapat számára",
        "Akár 4 felhasználós munkaállomások független beállításának lehetősége"
      ],
    ],
    image: "/uploads/S280-pano.jpg",
  },

  sections: [
    {
      title: "Verziók",
      cards: [
        {
          image: "/uploads/S380-cont.png",
          alt: "S300 Continental",
          title: "Continental",
          description: "Az S.P.R.I.D.O. modellhez képest ez a verzió egy kompakt modullal és olyan eszközökkel rendelkezik, amelyek csövei anélkül nyúlnak ki, hogy a csuklót megnyomnák. A fogorvos a modul fogantyúján található gomb megnyomásával kioldhatja az opcionális pneumatikus féket a modul magasságának beállításához.",
        },
        {
          image: "/uploads/S380-inter.png",
          alt: "S300 International",
          title: "International",
          description: "Ennél a változatnál a műszerek függőcsövekkel rendelkeznek, ergonomikus elrendezésben az egyszerű kezelés érdekében. A fecskendő függőlegesen helyezkedik el a kézidarab-tartó elején, így biztosítva a jó fogást. Ez a modell tökéletes azoknak a szakembereknek, akik szeretnek 12 órás pozícióban dolgozni.",
        },
        {
          image: "/uploads/S380-inter.png",
          alt: "S300 International",
          title: "Hybrid",
          description: "This S.P.R.I.D.O. model increases the ergonomic versatility of the dental unit. The dentist’s module arm can reach positions all round the treatment zone and the assistant's module can be shifted to either side of the patient chair.",
        }
      ],
    },
    {
      title: "Innovációk",
      cards: [
        {
          image: "/uploads/S300-voice.png",
          alt: "S300 Continental",
          title: "Hangvezérlés",
          description: "A személyzet és a műszerek közötti interakció még agilisabbá tétele érdekében a virtuális hangalapú asszisztens rendszer számos munkafolyamat-javítási lehetőséget kínál. Például az asszisztensek/fogorvosok hangvezérléssel kezelhetik a műtőlámpát.",
        },
        {
          image: "/uploads/S300-pack.png",
          alt: "S300 International",
          title: "Interaktív LED",
          description: "Ez az opcionális alkalmazás színes LED-eket használ, hogy gyors és könnyen érthető állapotinformációkat nyújtson a különböző funkciókról, a fogkőeltávolító módtól a fogászati ​​egység higiéniai ciklusának előrehaladásáig. Hasznos gyökérkezelések során is aktív apex lokátorral.",
        },
        {
          image: "/uploads/S300-nfc.png",
          alt: "S300 International",
          title: "NFC támogatás",
          description: "Az azonnali NFC-kapcsolat akár 20 felhasználó számára biztosít hozzáférést a személyre szabott beállításokhoz. A munkabeállítások engedélyezéséhez csak közelítsd a könnyen fertőtleníthető szilikon karkötőt a modulhoz.",
        }
      ],
    },

    {
      title: "Konzol",
      cards: [
        {
          image: "/uploads/S380-touch.png",
          alt: "S200 Digit Console",
          title: "7 hüvelykes multitouch kijelző",
          description:
            "A letisztult, könnyen használható felület nagyobb fokú testreszabhatóságot és a kulcsfontosságú információk gyors megjelenítését teszi lehetővé. Klinikai környezetre tervezve, ütés- és vízálló, és az Ön igényeinek megfelelően pozícionálható.",
        },
        {
          image: "/uploads/S380-usb.png",
          alt: "S200 Digit Console",
          title: "USB csatlakozás",
          description:
            "A fogorvosok az USB-porton keresztül feltölthetik/letölthetik a diagnosztikai képeket, ha van integrált multimédiás rendszer.",
        },
        {
          image: "/uploads/S380-profile.png",
          alt: "S200 Digit Console",
          title: "Több profilú menedzsment",
          description:
            "A klinikai igényektől függően az S380TRC-n dolgozó fogorvosok testre szabhatják az összes működési paramétert, és közvetlenül a kezelőpanelen vagy USB-meghajtón menthetik el.",
        }
      ],
    },

    {
      title: "Konzervatív Fogászat",
      cards: [
        {
          image: "/uploads/S200-mikromotor.png",
          alt: "S200 Digit Console",
          title: "FLUO mikromotorok i-XS4 és i-XR3L",
          description:
            "Könnyűek és még a korábbiaknál is halkabbak, a Stern Weber mikromotorok FIT (fluoreszcencia-alapú azonosítási technika) technológiával kaphatók, hogy könnyebben felismerjék a fogakban lévő kompozit anyagokat, ezáltal felgyorsítva az eltávolítást.",
        }
      ],
    },

    {
      title: "Páciens szék",
      cards: [
        {
          image: "/uploads/S380-motor.png",
          alt: "S200 Digit Console",
          title: "Motoros forgás",
          description:
            "Az S380TRC motoros forgószékkel, térdtöréssel és motoros, kihúzható lábtartóval rendelkezik. Az üléspozíció különösen alkalmas fogszabályozási kezelésekhez.",
        },
        {
          image: "/uploads/S200-standard.png",
          alt: "S200 Digit Console",
          title: "Normál háttámla",
          description:
            "Ez a háttámla úgy van kialakítva, hogy a fogászati ​​személyzet könnyen közelebb tudjon lépni a pácienshez a kezelés során. Felnőttek, gyermekek és mindenféle kezeléshez alkalmas.",
        },
        {
          image: "/uploads/S200-nordic.png",
          alt: "S200 LCD Console",
          title: "Nordic háttámla",
          description:
            "Ez a háttámla nagyobb kényelmet biztosít a hosszú kezelések során, és úgy lett kialakítva, hogy segítse a „közvetett látásmódban” dolgozó fogorvosokat.",
        },
        {
          image: "/uploads/S200-atlaxis.png",
          alt: "S200 LCD Console",
          title: "Atlaxis háttámla",
          description:
            "A fejtámla hűen követi a páciens anatómiáját. A pneumatikus zár rendkívül egyszerű, ujjbeggyel történő kioldásával lehetővé válik a szemüreg mozgása a tökéletes pozicionálás érdekében, beleértve a függőleges beállítást is.",
        },
        {
          image: "/uploads/S200-memory.png",
          alt: "S200 LCD Console",
          title: "Memória hab",
          description:
            "A speciális kárpitozási megoldások (opcionális) kivételes kényelmet és hatékony anatómiai támasztást garantálnak.",
        }
      ],
    },
    {
      title: "Higénia",
      cards: [
        {
          image: "/uploads/S380-higenia.png",
          alt: "S200 Digit Console",
          title: "Tervezett higiénia",
          description:
            "A fogászati ​​egységek tervezése során arra összpontosítanak, hogy az orvosok a lehető legegyszerűbben elvégezhessék a szükséges feladatokat. Egyrészt a felhasználók akadálytalanul hozzáférhetnek az eszközökhöz, és könnyen ellenőrizhetik azokat; másrészt a könnyen fertőtleníthető anyagok megakadályozzák a keresztszennyeződés kockázatát.",
        },
        {
          image: "/uploads/S380-bioster.png",
          alt: "S200 LCD Console",
          title: "BIOSTER",
          description:
            "Ez az intenzív fertőtlenítő rendszer automatikus fertőtlenítési ciklusokat futtat a permetezővíz-körökön, teljes védelmet nyújtva a mikroorganizmusok fogászati ​​egységen belüli átvitele ellen.",
        },
        {
          image: "/uploads/S380-iwfc.png",
          alt: "S200 LCD Console",
          title: "I.W.F.C.",
          description:
            "A BIOSTER rendszer részeként vagy külön megvásárolható eszköz biztosítja a vízkörök tisztítását, miután a gép egy bizonyos ideig tétlen volt.",
        },
        {
          image: "/uploads/S380-whe.png",
          alt: "S200 LCD Console",
          title: "W.H.E",
          description:
            "Ez egy folyamatos, Peroxy Ag+ (H2O2) alapú fertőtlenítő rendszer, amely egy légrés-eszközzel együtt működik, amely elválasztja a fő víz- és fogászati ​​kezelőegység áramköreit. Hatékony minden vízben terjedő szennyeződés, beleértve a Legionellát is, ellen.",
        },
        {
          image: "/uploads/S380-acvs.png",
          alt: "S200 LCD Console",
          title: "A.C.V.S",
          description:
            "Ez az automatikus rendszer szívórendszer-fertőtlenítési ciklusokat végez két beteg között.",
        },
        {
          image: "/uploads/S380-sanaspray.png",
          alt: "S200 LCD Console",
          title: "Sanapray",
          description:
            "Ez a desztilláltvíz-tartály, amelyet a vezetékes víz alternatívájaként kell használni.",
        }
      ],
    },
    {
      title: "Világítás",
      cards: [
        {
          image: "/uploads/S200-mct.png",
          alt: "S200 LCD Console",
          title: "Venus Led Mct",
          description:
            "Ez a verzió lehetővé teszi a színhőmérséklet (meleg, semleges és hideg) beállítását az anatómiai részletek pontosabb elemzése érdekében. A kompozit mód elkerüli a kompozitok előpolimerizációját, optimalizálva a helyreállítási eljárásokat.",
        },
        {
          image: "/uploads/S200-mct-view.png",
          alt: "S200 LCD Console",
          title: "Venus Led Mct View",
          description:
            "Ez a verzió egy 4K kamerát tartalmaz, amely segíti a betegekkel való kommunikációt és értékes klinikai dokumentációs eszközt biztosít. A folyékony lencsékkel ellátott Smart Focus rendszer pontos, automatikus fókuszálást biztosít manuális beállítások nélkül.",
        }
      ],
    }
  ],
};

export default S380;